module.exports = __webpack_public_path__ + "static/img/blog_good_6.09cb19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_6.png
// module id = 2ifa
// module chunks = 8